import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth/auth.guard';
import { AuthSecurityGuard } from './auth/authSecurity.guard';
import { ForgotPasswordFinishComponent } from './main/pages/authentication/forgot-password-finish/forgot-password-finish.component';
import { ForgotPasswordComponent } from './main/pages/authentication/forgot-password/forgot-password.component';
import { LoginComponent } from './main/pages/authentication/login/login.component';
import { RecoverRegistryComponent } from './main/pages/authentication/register/recover-registry/recover-registry.component';
import { RegisterCompleteComponent } from './main/pages/authentication/register/register-complete/register-complete.component';
import { RegisterComponent } from './main/pages/authentication/register/register.component';
import { UnlockComponent } from './main/pages/authentication/unlock/unlock.component';
import { NotFoundPageComponent } from './main/pages/generals/not-found-page/not-found-page.component';
import { HomeComponent } from './main/pages/home/home.component';
import { ProfileComponent } from './main/pages/profile/profile.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'auth/register',
    component: RegisterComponent,
    canActivate: [AuthSecurityGuard],
  },
  {
    path: 'auth/register/complete',
    component: RegisterCompleteComponent,
  },
  {
    path: 'auth/login',
    component: LoginComponent,
    canActivate: [AuthSecurityGuard],
  },
  {
    path: 'auth/register/recover',
    component: RecoverRegistryComponent,
    canActivate: [AuthSecurityGuard],
  },
  {
    path: 'auth/unlock',
    component: UnlockComponent,
    canActivate: [AuthSecurityGuard],
  },
  {
    path: 'auth/forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [AuthSecurityGuard],
  },
  {
    path: 'auth/forgot-password-finish',
    component: ForgotPasswordFinishComponent,
    canActivate: [AuthSecurityGuard],
  },
  {
    path: 'dashboard',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    component: NotFoundPageComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
